import axios from './axiosConfig';
import constants from "../../constants/constants";
/**
 * @name fetchApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
/**
 * @name fetchAdminApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
export const fetchApi = (param = null, method = null, variables = null) =>
	axios({
		method,
		url: `${constants.ApiUrl}${param}`,
		data: variables
	})
		.then(res => res.data)
		.catch(err => handleApiError(err));
/**
 * Admin API
 */
export const fetchAdminApi = (param = null, method = null, variables = null) =>
	axios({
		method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables
	})
		.then(res => res.data)
		.catch(err => handleApiError(err));
/**
 * Admin Download API
 */
export const fetchAdminDownloadApi = (param = null, method = null, variables = null) =>
	axios({
		method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables,
		responseType: 'blob'
	})
		.then(res => res.data)
		.catch(err => handleApiError(err));
/**
 * User Download API
 */
export const fetchDownloadApi = (param = null, method = 'get', variables = null) =>
	axios({
		method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		responseType: 'blob'
	})
		.then(res => {
			const filename = extractFilename(res.headers['content-disposition']);
			return {
				data: res.data,
				fileName: filename
			};
		})
		.catch(err => handleApiError(err));
/**
 * Centralized error handler
 */
const handleApiError = (err) => {
	if (!err.response) return Promise.reject(err);
	const { status, data } = err.response;
	if (status === 401) {
		if (data?.code === 403 && data?.error_message === "Access Denied") {
			return window.location.href = constants.BaseUrl + "/";
		}
		return Promise.reject({
			type: "UNAUTHORIZED",
			message: data.message || data.error_message
		});
	}
	if (status === 400) {
		return Promise.reject(data.message || data.error_message);
	}
	if (status === 429) {
		return Promise.reject({
			code: 429,
			message: data.message
		});
	}
	return Promise.reject(err);
};
/**
 * Helper for filename extraction
 */
const extractFilename = (contentDisposition) => {
	let filename = 'downloaded_file';
	if (contentDisposition) {
		const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(contentDisposition);
		if (matches != null && matches[1]) {
			filename = matches[1].replace(/['"]/g, '');
		}
	}
	return filename;
};
